import { render } from "./CategoriesWithRecommendationModal.vue?vue&type=template&id=588f4b5e"
import script from "./CategoriesWithRecommendationModal.vue?vue&type=script&lang=js"
export * from "./CategoriesWithRecommendationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__